export class LoginItem {
  id        : string;
  name      : string;
  status    : boolean;
  area   : string;
  storeRole : storeRoles;
  phone   : string;
  email   : string;
  details: string;
  storeId : string;
  logoUrl : string;
  role    : Roles;
  uid? : string;
  isTest: boolean;
  ordersCount : number = 0;
  creationDate : Object = 0;
  password? : string;
  confirmPassword? : string;
  apikey? : string;
  send_order_auto? : string;

  constructor() {
    this.role = {
      user: false,
      admin: false,
      driver: false,
      store: true
    },

    this.storeRole = {
      home: true,
      details: true,
      stocks: true,
      orders: true,
      marketing: true,
      accounts: true,
      sales: true,
      analytics: true,
      settings: true
    }
  }
}

export class DriverItem {
  id        : string;
  name      : string;
  status    : boolean;
  phone   : string;
  email   : string;
  storeId : string;
  key  : string;
  isTest: boolean;
  creationDate : Object = 0;
  password? : string;
  confirmPassword? : string;

  constructor() {
  }
}

export class StoryItem {
  id        : string;
  details : string;
  nameSec : string;
  detailsSec : string;
  name      : string;
  status    : boolean;
  key  : string;
  views : string[] = []
  storeId: string;
  images : string[] = []
  creationDate : Object = 0;

  constructor() {
    this.views = []
  }
}

export class StoreItem {
  filesList : [FileItem];
  deskType : number = 0;
  mobType  : number = 0;
  orderLimit: number = 0;
  // For stats
  supplierCode : string = "";
  enablePickup : boolean = false;
  minimumOrder : number = 0;
  baseLat : number = 0;
  baseLng : number = 0;
  domainUrl : string = "";
  enableCustomDelivery: string = "";
  customDeliveryText: string = "";
  webUrl : string = "";
  domain : string = "";
  locations: LocationItem[] = []
  ordersCount    : number = 0;
  monthlyRevenue : number = 0;
  deliveryCharges : number = 0;
  progress : number = 0;
  supportEmail: string = ""
  currency : string = "KWD";
  defaultLanguage : string = "en";
  secLanguage : string = "none";
  bgImageUrl : string;
  logoUrl : string;
  details     : string;
  supportPhone: string;
  pixelId     : string;
  phone     : string;
  key       : string;
  email     : string;
  lastUpdate : number = 0;
  name      : string;
  bankAccount : string;
  category : string;
  orderPrefix: string;
  nameSecondary: string;
  detailsSecondary: string;
  tax    : number =  0;
  status    : boolean =  true;
  membership : string = "pending";
  scheduleLimit : number;
  soonAvailability : boolean;
  orderEmail : boolean;
  enableDelivery : boolean = true;
  timings  = [];
  password: string;
  creationDate : Object;
  checked: false;
  branches: BranchItem[] = []
  themes = {}
  paymentOptions = []
  networkList = []
  primaryColor : string = "#fff"
  primaryDarkColor : string = "#fff"

  constructor() {
    this.deskType = 0;
    this.mobType =  0;
  }
}

export class LocationItem{
  name : string;
  nameArabic: string;

  areasList : AreaItem[] = [];

  areas: string[];
  areasArabic: string[];

  minOrderPrice: number = 0;
  estimatedTime: string;
  fee: number = 0;
  expand: boolean = false;
  status: boolean = true;
}

export class AreaItem{
  name : string;
  nameArabic: string;
  minOrderPrice: number = 0;
  estimatedTime: string;
  fee: number = 0;
  status: boolean = true;
}

export class CategoryItem {
  index  : number = 0;
  status : boolean;
  logoUrl : string;
  details     : string;
  detailsSecondary     : string;
  key       : string;
  nameSecondary      : string;
  name      : string;
  items    : ProductItem[];
  creationDate : Object;

  constructor() {
    this.index = 0;
  }
}

export class BranchItem {
  status  : boolean;
  key     : string;
  name    : string;
  phone   : string;
  address : string;
  addressSecondary : string;
  nameSecondary    : string;
  coords : {lat: number, lng: number};
  creationDate : Object;
  timings  = [];

  constructor() {
  }
}

export class ProductItem {
  stockType : string = "normal"
  allowBaseTax    : boolean = true
  itemCode: string;
  tax : number = 0;
  allowStock : boolean = false;
  allowInstructions : boolean = false;
  productId : string = "";
  salesCount : number = 0;
  stock  : number = 0;
  images : string[] = []
  detailsSec  : string;
  categoryId     : string;
  details     : string;
  key       : string;
  name      : string;
  nameSec   : string;
  status    : boolean = false
  addons    : Object;
  creationDate : Object;
  price: number = 0;
  ordersCount: number = 0;
  index : number = 0;
  preparationText : string = ""
  preparationTextSec : string = ""
  constructor() {
    this.index = 0;
    this.stockType = "normal"
  }
}

export class AddonItem {
  index = 0;
  expanded: boolean = true;
  key: string;
  baseAddonKey: string;
  showColors : boolean = false;
  creationDate : Object;
  required : boolean = false
  status : boolean = false
  details   : string;
  detailsSec: string;
  name      : string;
  nameSec   : string;
  modifiers : ModifierItem[] = []
  minAllowed : number = 0;
  maxAllowed : number = 0;
  price : number;
}

export class ModifierItem {
  index = 0;
  key : string;
  modifierTags : AddonItem[] = []
  addonKey : string;
  creationDate : Object;
  details   : string;
  detailsSec: string;
  name      : string;
  nameSec   : string;
  price : number = 0;
  stock : number = 0;
  baseAddonKey : string;
  allowStock : boolean = false;
  color : string = "#000";
}


export class Roles {
  user: boolean;
  store?: boolean;
  admin?:  boolean;
  driver?:  boolean;
}

export class storeRoles {
  home?: boolean;
  details?: boolean;
  stocks?:  boolean;
  orders?:  boolean;
  marketing?: boolean;
  accounts?: boolean;
  sales?:  boolean;
  analytics?:  boolean;
  settings?:  boolean;
}

export class OrderItem {

  promoData : PromoItem;
  isNotified : boolean = true;
  deliveryCharges : number = 0
  deliveryData : DeliveryDataItem = new DeliveryDataItem()
  itemsPrice   : number = 0
  taxCharges : number = 0
  tax : number = 0
  payType: number = 10;
  totalPrice: number = 0;

  currency : string = "KWD";
  store    : StoreItem = new StoreItem()

  driverId : string;
  key      : string;

  promo : PromoItem;
  promoDiscount   : number;

  orderId   : string;
  storeId    : string;
  userData    : UsersData = new UsersData();

  status  : number;
  deliveryStatus : number;
  timestamp: number;
  finalizeDate: number;
  apikey?: string;

  orderData : OrderDataItem[] = []

  constructor() {
    this.orderId = ""
  }
}


export class LinkItem {
  transaction = {}
  attachments : string[] = []
  phone: string;
  email: string;
  name: string;

  address: string;
  city: string;
  area: string;

  sendEmail : boolean = false;
  sendSMS   : boolean = false;

  notes : string;
  deliveryCharges : number = 0

  taxCharges : number = 0

  discountValue : number = 0
  discountPercent : boolean = true

  discountPrice: number = 0;
  itemsPrice: number = 0;
  totalPrice: number = 0;
  payType : number = 0;

  totalPaid: number = 0;

  currency : string = "KWD";

  store    : StoreItem = new StoreItem()
  storeId : string;
  key      : string;
  referenceCode      : string;

  referenceId   : string;
  status  : number;

  expiryDate  : number;
  creationDate  : Object;

  orderData : LinkDataItem[] = []

  constructor() {
    this.currency = "KWD"
    this.sendEmail = false;
    this.sendSMS = false;
    this.referenceId = ""
  }
}

export class DeliveryDataItem {
  branch = undefined
  area = undefined
  timings = {date: ""}
  constructor() {
  }
}

export class LinkDataItem {
  price     : number = 0;
  quantity  : number = 1;
  name : string;

  constructor() {
  }
}

export class OrderDataItem {
  taxPrice  : number = 0;
  totalPrice: number = 0;
  itemPrice : number = 0;

  addons    : AddonItem[] = [];
  counter   : number = 1;
  price     : number = 0;

  expand: boolean = true;
  instructions : string;
  key  : string;
  categoryId  : string;
  name : string;

  constructor() {
  }
}

export class UsersData {
  instructions : string = "";
  building     : string;
  avenue       : string;
  block       : string;
  house       : string;
  street       : string;
  floor : string;
  usageLimit : number = 0;
  unitType : number = 0;
  email       : string;
  key          : string;
  phone        : string;
  name         : string;
  paymentType  : number;
  ordersCount : number;
  totalPrice : number;
  timestamp    : number;
  totalOrders: number;
  ratings : number =  0;
  location : LocationData;

  constructor() {
  }
}

export class LocationData {
  address     : string;
  timestamp  : number;
  coords  : object;
}

export class PromoItem {
  productsList  : ProductItem[]   = []
  categoriesList: CategoryItem[]  = []
  usersList     : UsersData[]     = [];
  minimumPurchase : number = 0;
  amount        = 0;
  type : number = 0;
  storeId : string;
  promoCode     : string;
  creationDate  : Object;
  title     : string;
  startDate     : number;
  endDate     : number;
  details   : string
  usageLimit : number = 0;
  usageCount : number = 0;
  status     : boolean;
  promotionType : number = 0;
  freeDelivery : boolean = false;
  isGeneral  : boolean;
  usedBy     : String[];
  multiUsage  : boolean;
  key : string;

  discountValue : number;

  constructor() {
    this.status = false;
    this.isGeneral = true;
  }
}

export class TopItemData {
  key     : string;
  name     : string;
  price  : number;
  count  : number;
  totalCount: number;
}

export class TopStoreData {
  name      : string;
  ordersCount : number;
  totalPurchases : number;
}

export class TopAreaData {
  name     : string;
  items  : number;
  orders  : number;
  amount: number;
}

export class SharedItemsData {
  name : string = "";
  price : number = 0;
  share : number = 0;
  views : number = 0;
  key : string = "";
}

export class FileItem {
  name    : string = "";
  detail  : string = "";
  url     : string = "";
  filePath : string = "";
  description : string = "";
}

export class BbItem {
  key : string;
  imageUrl : string = "";
  url: string = "";
  link: string = "";
  views : number;
  clicks : number;
  status : boolean;
  creationDate  : Object = 0;
}

export class SbItem {
  key : string;
  imageUrl : string = "";
  url: string = "";
  link: string = "";
  views : number;
  clicks : number;
  status : boolean;
  creationDate  : Object = 0;
}

export class VideoItem {
  key : string;
  videoUrl : string = "";
  title : string = "";
  opens : number;
  status : boolean;
  isNew : boolean;
  creationDate  : Object = 0;
}

export class EventItem {
  key : string;
  title : string = "";
  eventDate : Object = 0;
  status : boolean;
  isNew : boolean;
  creationDate  : Object = 0;
}

export class AlertItem {
  key : string;
  title : string = "";
  message: string = "";
  showCounts: number = 0;
  storeCounts: number = 0;
  storeName: string = "";
  alertHistory: AlertHistory;
  creationDate  : Object = 0;
}

export class AlertHistory {
  key : string;
  skey : string;
  sname : string = "";
  status : boolean;
}

export class UserItem{
  id : string = "";
  name : string = "";
  phone : string = "";
  totalOrders : number = 0;
  lastDate : string = "";
}
